import App from './App';

export { App };



// WEBPACK FOOTER //
// ./src/comparison/containers/index.js